(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arvue-tier-progress"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const source = document.getElementById('ArvueTierProgressSource');
      const template = document.getElementById('ArvueTierProgressTemplate');

      if (!source || !template) return;

      let latestCount = 0;
      let refreshTimer;
      let mountFrame;

      const mount = (location, target, position) => {
        if (!target || document.querySelector(`[data-arvue-location="${location}"]`)) return;

        const widget = template.content.firstElementChild.cloneNode(true);
        widget.dataset.arvueLocation = location;

        if (position === 'after') target.insertAdjacentElement('afterend', widget);
        if (position === 'before') target.insertAdjacentElement('beforebegin', widget);
        if (position === 'prepend') target.prepend(widget);
      };

      const mountWidgets = () => {
        if (source.dataset.arvueProductPage === 'true') {
          const productButtons = document.querySelector('.product__info-container .product-form__buttons');
          mount('product', productButtons, 'after');
        }

        if (latestCount > 0) {
          const drawerActions = document.querySelector('.mini-cart__footer .mini-cart__actions');
          const drawerFooter = document.querySelector('.mini-cart__footer');
          mount('drawer', drawerActions || drawerFooter, drawerActions ? 'before' : 'prepend');
          mount('cart', document.querySelector('.cart__contents'), 'prepend');
        }
      };

      const renderWidgets = (count) => {
        document.querySelectorAll('.arvue-tier').forEach((widget) => {
          const messages = widget.querySelector('.arvue-tier__messages');
          const status = widget.querySelector('[data-arvue-status]');
          const fill = widget.querySelector('[data-arvue-fill]');
          const step = Math.min(count, 5);
          const messageKey = step >= 5 ? 'five' : ['zero', 'one', 'two', 'three', 'four'][step];
          const progressByCount = [0, 8.333, 16.666, 50, 66.666, 83.333];

          status.textContent = messages.dataset[messageKey];
          fill.style.setProperty('--arvue-progress', `${progressByCount[step]}%`);

          widget.querySelectorAll('.arvue-tier__dot').forEach((dot, index) => {
            const thresholds = [2, 3, 5];
            dot.classList.toggle('is-active', count >= thresholds[index]);
          });
        });
      };

      const syncWidgets = () => {
        mountWidgets();
        renderWidgets(latestCount);
      };

      const updateWidgets = (count) => {
        latestCount = count;
        syncWidgets();

        if (count === 0) {
          document.querySelectorAll(".arvue-tier[data-arvue-location='drawer'], .arvue-tier[data-arvue-location='cart']").forEach((widget) => widget.remove());
        }
      };

      const scheduleSync = () => {
        cancelAnimationFrame(mountFrame);
        mountFrame = requestAnimationFrame(syncWidgets);
      };

      const refresh = async () => {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(async () => {
          try {
            const response = await fetch(source.dataset.cartUrl, { headers: { Accept: 'application/json' } });
            const cart = await response.json();
            const count = cart.items.reduce((total, item) => {
              return item.vendor === 'ARVUE' ? total + item.quantity : total;
            }, 0);
            updateWidgets(count);
          } catch (error) {
            scheduleSync();
          }
        }, 80);
      };

      const cartObserver = new MutationObserver(scheduleSync);
      cartObserver.observe(document.body, { childList: true, subtree: true });

      mountWidgets();
      refresh();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }

      document.addEventListener('cart:updated', refresh);
      document.addEventListener('cartdrawer:opened', refresh);
      document.addEventListener('shopify:section:load', refresh);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bloomy-bnpl"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateRoot = (root, priceInMinorUnits) => {
      const price = Number(priceInMinorUnits);
      if (!Number.isFinite(price)) return;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: root.dataset.currency || 'AED',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const amount = formatter.format(price / 100 / 4);
      root.querySelectorAll('[data-bloomy-installment]').forEach((node) => {
        node.textContent = amount;
      });
    };

    document.querySelectorAll('[data-bloomy-bnpl]').forEach((root) => {
      updateRoot(root, root.dataset.price);
    });

    if (window.bloomyBnplListenerReady) return;
    window.bloomyBnplListenerReady = true;
    document.addEventListener('variant:change', (event) => {
      if (!event.detail || !event.detail.variant) return;
      document.querySelectorAll('[data-bloomy-bnpl]').forEach((root) => {
        updateRoot(root, event.detail.variant.price);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
